import React from "react";
import CommunityDetail from "../../../components/CommunityDetail";

const CommunityBunriDetail = () => {
  return <CommunityDetail posttype="bunri" />;
};

export default CommunityBunriDetail;
